import { css } from "styled-components"

export const MobileSize = (props) => {
  return css`
    @media (max-width: 440px){
        ${props} 
    }
  `
}